export default {
  address: [
    'user-input',
    'map',
    'highway',
    'underground',
  ],
  'about-object': [
    'common/cadastral-number',
    'cottage-village-name',
    'build-year',
    'material-type-house',
    'suburban-total-area',
    'floors-count-house',
    'bedrooms-count',
    'visual-divider',
    'wc-location-type',
    'heating-type-house',
    'in-house-sale',
    'visual-divider',
    'area-land',
    'suburban-building-status',
  ],
  'price-and-deal-terms': [
    'price',
    'agent-bonus'
  ],
};
